import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mobile-footbar" }

import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileFootbar',
  setup(__props) {

/* eslint-disable vue/multi-word-component-names */
const route = useRoute()

const isActive = (section: string) => {
  const path = route.path
  
  switch (section) {
    case 'dashboard':
      return path === '/dashboard' || path === '/'
    case 'catalog':
      return path.startsWith('/catalog')
    case 'orders':
      return path.startsWith('/orders') || path.startsWith('/orderdetails') || route.name === 'myorders'
    case 'account':
      return path.startsWith('/account')
    default:
      return false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { path: '/dashboard' },
      class: _normalizeClass(["mobile-footbar-item", { 'is-active': isActive('dashboard') }])
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fas fa-chart-pie" }, null, -1),
        _createElementVNode("span", null, "Accueil", -1)
      ])),
      _: 1,
      __: [0]
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'account/infos' },
      class: _normalizeClass(["mobile-footbar-item", { 'is-active': isActive('account') }])
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fas fa-user-circle" }, null, -1),
        _createElementVNode("span", null, "Compte", -1)
      ])),
      _: 1,
      __: [1]
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'catalog/productlist' },
      class: _normalizeClass(["mobile-footbar-item", { 'is-active': isActive('catalog') }])
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "fas fa-box" }, null, -1),
        _createElementVNode("span", null, "Catalogue", -1)
      ])),
      _: 1,
      __: [2]
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'myorders' },
      class: _normalizeClass(["mobile-footbar-item", { 'is-active': isActive('orders') }])
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "fas fa-clipboard-list" }, null, -1),
        _createElementVNode("span", null, "Commandes", -1)
      ])),
      _: 1,
      __: [3]
    }, 8, ["class"])
  ]))
}
}

})